import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import * as moment from 'moment';
import {LocalStorageService} from 'angular-2-local-storage';

@Injectable()
export class BaseService {

  constructor(private storage: LocalStorageService) {
  }

  protected replacerFunction(key, value) {
    if (this[key] instanceof Date) {
      return moment(this[key]).format('YYYY-MM-DDTHH:mm:ssZZ');
    }
    return value;
  }

  public stringify(thing: any) {
    return JSON.stringify(thing, this.replacerFunction);
  }
}
